import { showErrorNotification } from 'modules/notification/notification$';
import { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { dispatchAction } from 'rxbeach';
import { post$ } from 'services/api';
import { logError } from 'services/logger';
import { getBase64 } from './utils';

type UseFileUploadProps = {
  url: string;
  onSuccess: (path: string) => void;
  directory?: string;
};

const useFileUpload = ({ url, onSuccess, directory }: UseFileUploadProps) => {
  const [loading, setLoading] = useState(false);
  const onDrop = useCallback(async ([acceptedFile]: File[]) => {
    setLoading(true);
    const file = await getBase64(acceptedFile);
    const result = await post$<any>(url, {
      encodedFile: file,
      key: acceptedFile.name,
      type: acceptedFile.type,
      directory,
    }).catch((error) => {
      setLoading(false);
      logError(error, 'Failed to upload file');
      if (typeof error !== 'string') return;
      dispatchAction(
        showErrorNotification(
          typeof error === 'string'
            ? error
            : 'Noe feil skjedde med opplasting av fil'
        )
      );
    });
    if (result) {
      setLoading(false);
      onSuccess(result.key);
    }
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  return { loading, getRootProps, getInputProps, isDragActive };
};

export default useFileUpload;
